import { Site } from '@envato/foundation-types'
import * as normalizeUrl from 'normalize-url'
import { match } from 'react-router-dom'
import intersection from 'lodash-es/intersection'

import ga from '../../utils/ga'
import { parseLocation } from '../../utils/urlHelper'
import { hasFeature } from '../features'
import { formatSearchLocationParams } from './format'
import { ICommonLocation, ILocationParams, IQuery, IFlatQuery } from './types'
import { searchFrontendParams } from '../../constants/searchQueryWhitelist'

interface IGetSearchLocationParamsProps {
  location: ICommonLocation
  routeMatch: match<any>
  currentSite: Site
  experiments?: any
}

type NullablePartial<T> = { [P in keyof T]?: T[P] | null }

export const stringUrlsEqual = (a: string, b: string) => {
  if (a === b) {
    return true
  }

  return (
    normalizeUrl(a, { removeTrailingSlash: false }) ===
    normalizeUrl(b, { removeTrailingSlash: false })
  )
}

export const redirectToItemPage = (itemId: string) => {
  if (typeof window !== 'undefined') {
    ga('set', 'searchByItemId', window.location.href)
  }

  return `/item/by-id/${itemId}`
}

export const getLocationParams = (
  location: ICommonLocation,
  routeMatch: match<IFlatQuery>
): IQuery => ({
  ...location.query,
  ...routeMatch.params
})

export const getSearchLocationParams = ({
  location,
  routeMatch,
  currentSite,
  experiments
}: IGetSearchLocationParamsProps): ILocationParams => {
  if (hasFeature('routes:new', currentSite, location, experiments)) {
    return formatSearchLocationParams(getLocationParams(location, routeMatch))
  }

  return parseLocation({
    pathname: location.pathname || '/',
    query: location.query
  }) as Record<string, string>
}

export const getSearchTypeFromLocationParams = (
  locationParams: ILocationParams
) => {
  if (locationParams.category) {
    return 'category'
  } else if (locationParams.tags) {
    return 'tags'
  } else {
    return 'search'
  }
}

export const convertToCommonLocation = (
  location: NullablePartial<ICommonLocation>
): ICommonLocation => ({
  pathname: location.pathname || '/',
  search: location.search || '',
  query: location.query || {},
  hash: location.hash || ''
})

export const hasSearchPageQueryParams = (query: IQuery) =>
  !!intersection(Object.keys(query), searchFrontendParams).length
